import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AccessRole, CustomTitle, LoadingPanelService, LocalService, VisorComponent } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { IGetSeguimientoDocumento } from '../../../../../../shared/interfaces/database/pqrsd';
import { SegDocumentosService } from '../../../../../../services/database/pqrsd/seg-documentos.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import saveAs from 'file-saver';

@Component({
  selector: 'app-seguimiento-documentos',
  standalone: true,
  imports: [CommonModule, CustomTitle, ButtonModule, SkeletonModule, VisorComponent],
  templateUrl: './seguimiento-documentos.component.html',
  styleUrl: './seguimiento-documentos.component.scss'
})
export class SeguimientoDocumentosComponent implements OnInit {
  @Input() seguimientoId!: number;

  trans: any = {};
  data !: IGetSeguimientoDocumento[];
  role = AccessRole;
  isLoading = true;
  @ViewChild(VisorComponent) visorDialog !: VisorComponent;

  constructor(private readonly _sds: SegDocumentosService, private readonly _t: TranslateService, public ls: LocalService,
    private readonly _lps: LoadingPanelService
  ) { }

  ngOnInit(): void {
    this.translate();
    this.getSeguimientoDocumentos();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      documentos: this._t.get('common.documentos'),
      abrir: this._t.get('form.button.abrir'),
      descargar: this._t.get('common.descargar'),
      noHayDocumentos: this._t.get('msg.noHayDocumentos'),
      noPermisoDescargar: this._t.get('msg.noPermisoDescargar')
    }));
  }

  private getSeguimientoDocumentos() {
    this.isLoading = true;
    this._sds.getSeguimientoDocumento(this.seguimientoId).subscribe({
      next: (data: IGetSeguimientoDocumento[]) => {
        this.data = data;
      }, complete: () => {
        this.isLoading = false;
      }
    });
  }

  downloadFormFile(saveFile: boolean, id: number, fileName: string) {
    this._lps.show(true);
    this._sds.downloadFormFile(id).subscribe({
      next: (response: Blob) => {
        this._lps.hide();
        if (response.size > 0) {
          if (saveFile)
            saveAs(response, fileName);
          else
            this.visorDialog.showDialog(response);
        }
      }
    });
  }
}
